import type { DaySummary, Rag } from '../types'

interface RagMeta {
  label: string
  color: string
  soft: string
  ink: string
}

export const RAG_META: Record<Rag, RagMeta> = {
  green: { label: 'Fully covered', color: 'var(--green)', soft: 'var(--green-soft)', ink: 'var(--green-ink)' },
  amber: { label: 'Partly covered', color: 'var(--amber)', soft: 'var(--amber-soft)', ink: 'var(--amber-ink)' },
  red: { label: 'Needs people', color: 'var(--red)', soft: 'var(--red-soft)', ink: 'var(--red-ink)' },
  none: { label: 'No shifts', color: 'var(--line)', soft: 'transparent', ink: 'var(--muted)' },
}

export function coveragePct(d: DaySummary): number {
  return Math.round(d.coverage * 100)
}
